<template>
  <div class="title">
    {{ $t(`error_message.${messageId}`) }}
  </div>
</template>

<script>
export default {
  name: 'Error',
  props: {
    messageId: String
  }
}
</script>

<style>
.title {
  color: white;
  text-align: center;
  padding: 16px;
}
</style>
